// tslint:disable jsx-no-lambda
import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import { alertSettingsActions, doesStringExistInArr, globalActions } from "../../actions";

import { MPDAnimations } from "src/mpd-library/";

import { RightPanelContainer, ToolBar } from "src/components";

import SideBar from '../sidebar/sidebar';

import { SettingsItems, SettingsLeftPanel } from './components';

import GroupsSettings from './groups-settings/groups-settings';
import IPawsSettings from './ipaws-settings/ipaws-settings';
import SocialSettingsEdit from './social-settings-edit/social-settings-edit';
import SocialSettings from './social-settings/social-settings';

import { Redirect, Route, Switch } from "react-router-dom";

import "./styles.css";

export interface IMPDAlertSettingsProps {
  isMobileSize: boolean;
  mobileSideBarActive?: boolean;
  routeProps?: any;
  windowHeight: number;
  rightPanelExpanded: boolean;
  topBarProps: any;
  onCloseRightPanel: (
    pathname: string,
    history: any
  ) => (dispatch: Dispatch<any>) => Promise<void>;
  onToggleMobileSideBar: () => (dispatch: Dispatch<any>) => Promise<void>;
  onToggleRightPanel: () => (dispatch: Dispatch<any>) => Promise<void>;
  onUpdateToolBar: (
    topBarProps: any
  ) => (dispatch: Dispatch<any>) => Promise<void>;
}

class AlertSettings extends React.Component<IMPDAlertSettingsProps> {
  constructor(props: any) {
    super(props);
    this.onToggleRightPanel = this.onToggleRightPanel.bind(this);
    this.onCloseRightPanel = this.onCloseRightPanel.bind(this);
    this.onSettingsItemClick = this.onSettingsItemClick.bind(this);
  }

  public componentDidMount() {
    setTimeout(() => {
      window.scrollTo(0,0);
      const divHeight = document.getElementById('app-container');
      if(divHeight){
        divHeight.scrollTo(0,1);
      }
    }, 500);
  }

  public render() {
    const { isMobileSize, routeProps, mobileSideBarActive, rightPanelExpanded, topBarProps, onUpdateToolBar } = this.props;
    const pathname = routeProps.history.location.pathname;
    const pathnameArr = pathname.split('/');
    const mobileActive = pathnameArr[pathnameArr.length - 1] !== "alerts-settings";

    return (
      <div className='settings-controller-container'>
        <SideBar
          routeProps={routeProps}
          active={mobileSideBarActive}
          homeGroupIndex={1}
          homeItemIndex={2}
        />
        <Route
          path={"/alerts-settings"}
          exact={isMobileSize}
          render={() => (
            <SettingsLeftPanel 
              title='Alert Settings'
              rightPanelExpanded={rightPanelExpanded}
              mobileSideBarActive={mobileSideBarActive}
              onToggleMobileSideBar={this.props.onToggleMobileSideBar}
            > 
            {this.renderSettings()}
            </SettingsLeftPanel>
          )}
        />
        {((isMobileSize && mobileActive) || !isMobileSize) && (
          <RightPanelContainer 
            expanded={rightPanelExpanded}
            animationProps={{
              animation: MPDAnimations.growOut,
              animationActive: isMobileSize
            }}
          >
            <ToolBar {...topBarProps} key={routeProps.history.location} />
            <Switch location={routeProps.history.location}>
              <Route
                exact={true}
                path={"/alerts-settings/twitter/"}
                render={() => (
                  <SocialSettings
                    accountType={'twitter'}
                    routeProps={routeProps}
                    onCloseRightPanel={this.onCloseRightPanel}
                    onToggleRightPanel={this.onToggleRightPanel}
                  />
                )}
              />
              <Route
                exact={true}
                path={"/alerts-settings/facebook/"}
                render={() => (
                  <SocialSettings
                    accountType={'facebook'}
                    routeProps={routeProps}
                    onCloseRightPanel={this.onCloseRightPanel}
                    onToggleRightPanel={this.onToggleRightPanel}
                  />
                )}
              />
              <Route
                path={"/alerts-settings/ipaws/"}
                render={() => (
                  <IPawsSettings
                    accountType={'ipaws'}
                    routeProps={routeProps}
                    onUpdateToolBar={onUpdateToolBar}
                    onCloseRightPanel={this.onCloseRightPanel}
                    onToggleRightPanel={this.onToggleRightPanel}
                  />
                )}
              />
              <Route
                path={"/alerts-settings/twitter/edit/"}
                render={() => (
                  <SocialSettingsEdit
                    accountType={'twitter'}
                    routeProps={routeProps}
                    onCloseRightPanel={this.onCloseRightPanel}
                    onToggleRightPanel={this.onToggleRightPanel}
                  />
                )}
              />
              <Route
                path={"/alerts-settings/facebook/edit/"}
                render={() => (
                  <SocialSettingsEdit
                    accountType='facebook'
                    routeProps={routeProps}
                    onCloseRightPanel={this.onCloseRightPanel}
                    onToggleRightPanel={this.onToggleRightPanel}
                  />
                )}
              />
              <Route
                path={"/alerts-settings/groups/"}
                render={() => (
                  <GroupsSettings
                    itemType='groups'
                    routeProps={routeProps}
                    onCloseRightPanel={this.onCloseRightPanel}
                    onToggleRightPanel={this.onToggleRightPanel}
                  />
                )}
              />
              {!isMobileSize && <Redirect exact={true} from="/alerts-settings" to="/alerts-settings/twitter/" /> }
            </Switch>
          </RightPanelContainer>
          )}
      </div>
    );
  }

    // private toggleFullScreen() {
    //   const doc: any = window.document;
    //   const docEl: any = doc.documentElement;
    //   if(docEl){
    //     const requestFullScreen = docEl.requestFullscreen || docEl.mozRequestFullScreen || docEl.webkitRequestFullScreen || docEl.msRequestFullscreen;
    //     const cancelFullScreen = doc.exitFullscreen || doc.mozCancelFullScreen || doc.webkitExitFullscreen || doc.msExitFullscreen;
      
    //     if(!doc.fullscreenElement && !doc.mozFullScreenElement && !doc.webkitFullscreenElement && !doc.msFullscreenElement) {
    //       requestFullScreen.call(docEl);
    //     }
    //     else {
    //       cancelFullScreen.call(doc);
    //     }
    //   }
    //   window.scrollTo(0,1)
    // }


  private renderSettings() {
    const { routeProps } = this.props;
    const pathname = routeProps.history.location.pathname;
    const topItems = ['Twitter', 'Facebook', 'Google Alerts', 'iPAWS', 'Voice', 'SMS', 'Email'];
    const bottomItems = ['Groups', 'Map Layers', 'Export', 'Audit Log', 'Security'];
    const activeTopIndex =  doesStringExistInArr(pathname, topItems);
    const activeBottomIndex = doesStringExistInArr(pathname, bottomItems);

    return (
      <div className='alert-settings-container'>
        <SettingsItems
            activeIndex={activeTopIndex}
            title='Channels'
            items={topItems}
            onItemClick={this.onSettingsItemClick}
        />
        <SettingsItems
            activeIndex={activeBottomIndex}
            title='Manage'
            items={bottomItems} 
            onItemClick={this.onSettingsItemClick}
        />
      </div>
    );
  }

  private onToggleRightPanel(event?: React.MouseEvent<any>) {
    this.props.onToggleRightPanel();
  }

  private onCloseRightPanel() {
    const { history } = this.props.routeProps;
    const pathname = '/alerts-settings';
    this.props.onCloseRightPanel(pathname, history);
  }

  private onSettingsItemClick(item: string) { 
    const { routeProps } = this.props;
    routeProps.history.push('/alerts-settings/' + item);
  }

  
}

const mapStateToProps = (state: any) => {
  const { alertSettings, global } = state;
  const { isMobileSize, topBarProps, windowHeight, mobileSideBarActive } = global;
  const { rightPanelExpanded } = alertSettings;
  return {
    isMobileSize,
    topBarProps,
    rightPanelExpanded,
    mobileSideBarActive,
    windowHeight
  };
};

const mapDispatchToProps = (dispatch: Dispatch<any>) => {
  return {
    onUpdateToolBar: bindActionCreators(
      globalActions.onUpdateToolBar,
      dispatch
    ),
    onToggleRightPanel: bindActionCreators(
      alertSettingsActions.onToggleRightPanel,
      dispatch
    ),
    onCloseRightPanel: bindActionCreators(
      alertSettingsActions.onCloseRightPanel,
      dispatch
    ),
    onToggleMobileSideBar: bindActionCreators(
      globalActions.onToggleMobileSideBar,
      dispatch
    ),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AlertSettings);



// WEBPACK FOOTER //
// ./src/controllers/alert-settings/alert-settings.tsx